// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"MobileNavbar_bottomNav__H987-","nav":"MobileNavbar_nav__2DB7X","navText":"MobileNavbar_navText__tUnZJ","activeNavText":"MobileNavbar_activeNavText__1sgSL"};